<template lang="pug">
.plan-list-item
  v-list-tile
    v-list-tile-sub-title
      slot
  v-divider(v-if='!end')
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    end: { type: Boolean },
  },
})
</script>

<style scoped lang="sass">
.plan-list-item
  display: contents
</style>
